import { cn } from "@/core/helpers/cn";
import FactionAvatar from "@/domains/faction/components/FactionAvatar";
import FactionTextBlock from "@/domains/faction/components/FactionTextBlock";

type Props = {
  src: string;
  id: number;
  name: string;
  rank: string;
  position: string;
  className?: string;
  textClassName?: string;
};

export default function FactionParticipantCard({
  src,
  id,
  name,
  rank,
  position,
  className,
  textClassName,
}: Props) {
  return (
    <div className={cn("p-4 bg-dark-800 rounded-2xl", className)}>
      <div className="flex justify-between items-start mb-2">
        <FactionAvatar src={src} />
        <FactionTextBlock
          className="h-auto py-[0.4375rem] px-2.5 bg-[#212121] rounded-[0.3125rem]"
          classNameText1="text-[#B8B8B8] normal-case"
          text={`sID ${id}`}
        />
      </div>
      <FactionTextBlock
        text={name}
        text2={position}
        className={cn("flex-col items-start h-auto mb-3 p-0 bg-transparent", textClassName)}
        classNameText1="text-[0.9375rem] text-white normal-case"
        classNameText2="text-[0.875rem] text-white/70 normal-case"
      />
      <FactionTextBlock text={rank} />
    </div>
  );
}
